import { PublicKey } from '@solana/web3.js';

export const _MARKETS = [
  {
    name: 'SOL/USDT',
    deprecated: false,
    address: new PublicKey('2AdaV97p6SfkuMQJdu8DHhBhmJe7oWdvbm52MJfYQmfA'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'NRA/USDC',
    deprecated: false,
    address: new PublicKey('C3Hv6qZfoB2TxDQBy8UWJ3y1q4kZhMHsp1goLq3sb7xu'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'SOL/USDC',
    deprecated: false,
    address: new PublicKey('8BnEgHoWFysVcuFFX7QztDmzuH8r5ZFvyP3sYwn1XTh6'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'WOOF/USDC',
    deprecated: false,
    address: new PublicKey('iufycE4CrRMVHkgym27q28SEyCZ3ZHsN3rLxbPXA7m2'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'MOLA/USDC',
    deprecated: false,
    address: new PublicKey('HE1nibjUq5cTi6Zer5679od58PDAjtPAjTetUuV5XMPn'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'RAY/USDC',
    deprecated: false,
    address: new PublicKey('DZjbn4XC8qoHKikZqzmhemykVzmossoayV9ffbsUqxVj'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'RAY/USDT',
    deprecated: false,
    address: new PublicKey('GpHbiJJ9VHiuHVXeoet121Utrbm1CSNNzYrBKB8Xz2oz'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'MNGO/USDC',
    deprecated: false,
    address: new PublicKey('3NnxQvDcZXputNMxaxsGvqiKpqgPfSYXpNigZNFcknmD'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'ETH/USDT',
    deprecated: false,
    address: new PublicKey('BbJgE7HZMaDp5NTYvRh5jZSkQPVDTU8ubPFtpogUkEj4'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'BONK/USDC',
    deprecated: false,
    address: new PublicKey('8PhnCfgqpgFM7ZJvttGdBVMXHuU4Q23ACxCvWkbs1M71'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'SOLDOGE/USDC',
    deprecated: false,
    address: new PublicKey('Gmjq4394AB5eVtL4ELTraDVgXAn62Mk4r58H3xW5aTAe'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'ARB/USDC',
    deprecated: false,
    address: new PublicKey('5xCudgPvVetTL3M4ExtPuAFTnCr2hdQ3cte9LhGAuBee'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  {
    name: 'ORCA/USDC',
    deprecated: false,
    address: new PublicKey('BEhRuJZiKwTdVTsGYjbHRh9RmGbKBtT6xo7yPqxLiSSY'),
    programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  },
  
  // ,{
  //   name: 'BTC/USDT',
  //   deprecated: false,
  //   address: new PublicKey('C1EuT9VokAKLiW7i2ASnZUvxDoKuKkCpDDeNxAptuNe4'),
  //   programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  // },
  // {
  //   name: 'BTC/USDC',
  //   deprecated: false,
  //   address: new PublicKey('A8YFbxQYFVqKZaoYJLLUVcQiWP7G2MeEgW5wsAQgMvFw'),
  //   programId: new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX'),
  // }
];